import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchEmployeeDropdownAutoList, fetchShiftReportRequest, resetAttendanceReport } from "store/actions";
import Loader from "common/pageLoader";

const AttendanceReportShiftDetail = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    dropdownAutoList,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.AttendanceReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.AttendanceReportReducer?.loading,
    error: state.AttendanceReportReducer?.error,
    success: state.AttendanceReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetAttendanceReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      employee:""
    },
    onSubmit: (values) => {
      // console.log("Form Values:", values);
       const formData = new FormData();
      formData.append("dep_id", values.department || 0);
      formData.append("cat_id", values.category || 0);
      formData.append("emp_code", values.employee || 0);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchShiftReportRequest(formData))
    },
  });

  const columns = [
    { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", },
    { Header: "Code", accessor: "emp_code" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },  
    { Header: "Weekoff", accessor: "week_off" },
    { Header: "Shift Group", accessor: "shift_group" },
    { Header: "Shift", accessor: "shift" },
    { Header: "ShiftChange", accessor: "shift_change" },
  ];

  const handleReset = () => {
      formik.resetForm(); 
      dispatch(resetAttendanceReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading}/>
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Shift Detail" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>                

                <Col md={3}>
                  <Label>Department</Label>
                  <CustomSelect
                      id="department"
                      name="department"
                      options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                      value={
                        departments
                          .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                          .find(dept => dept.value === formik.values.department) || null
                      }
                      onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                      onBlur={formik.handleBlur}
                      className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                    />
                </Col>
                <Col md={3}>
                    <Label>
                      Employee
                    </Label>
                    <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(emp => ({
                          value: String(emp.emp_id),
                          label: emp.emp_no
                        }))}
  
                        // UI needs the object, so find matching option
                        value={
                          dropdownAutoList
                            .map(emp => ({
                              value: String(emp.emp_id),
                              label: emp.emp_no
                            }))
                            .find(option => option.value === formik.values.employee) || null
                        }
  
                        // Form Data: store string only
                        onChange={(selected) =>
                          formik.setFieldValue("employee", selected ? selected.value : "")
                        }
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">
                          {formik.errors.employee}
                        </div>
                      )}
                  </Col>
                <Col className="d-flex align-items-center justify-content-end mob-center">
                  <Button type="submit" className="btn button-search me-2 mt-4">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-4" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-4">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Shift details Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Shift details Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>            
            <TableContainer
              columns={columns}
              data={employeeReport}
              isGlobalFilter={true}
              customPageSize={10}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportShiftDetail;
